// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { wishListSharingStatusStyles } from "@insite/content-library/Components/WishListSharingStatus";
import Users from "@insite/mobius/Icons/Users";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

wishListSharingStatusStyles.privateTooltip = {
    cssOverrides: {
        tooltipClickable: css`
            margin-left: 5px;
            display: inline;
            @media print {
                display: none;
            }
        `,
    },
};

wishListSharingStatusStyles.sharedIcon = {
    src: Users,
    size: 15,
    color: "primary",
    css: css`
        margin-right: 5px;
    `,
};

wishListSharingStatusStyles.statusText = {
    css: css`
        &:hover {
            svg {
                color: ${getColor("secondary")};
            }
        }
    `,
};
